/* src/app/components/payroll/timesheets/timesheet-staff-authdata/timesheet-staff-authdata.component.css */
.custom-font-size {
  font-size: 14px !important;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
::ng-deep ppl-timesheet-staff-authdata span.hyperlink:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
/*# sourceMappingURL=timesheet-staff-authdata.component-WH5WPKSE.css.map */
